export default defineComponent({
  name: "MyFooter"
});